'use client';

import { Icon } from '@to/ui';

interface AgentEmptyStateProps {
  /** Optional override for the muted sub-message under the heading. */
  message?: string;
}

/**
 * Zero-results placeholder for the Find Your Agent results grid (Phase 31).
 * Centered glyph + heading + muted hint. Every color via `--brand-*`; icon via
 * `Icon` (Material Symbols Rounded: `person_search`).
 */
export function AgentEmptyState({ message }: AgentEmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center px-6 py-20 text-center">
      <span style={{ color: 'var(--brand-input-placeholder)' }}>
        <Icon name="person_search" size={56} />
      </span>
      <h3
        className="mt-4 text-lg font-semibold"
        style={{ color: 'var(--brand-text)' }}
      >
        No agents found
      </h3>
      <p
        className="mt-1 text-sm"
        style={{ color: 'var(--brand-text-muted)' }}
      >
        {message ?? 'Try adjusting your search or filters.'}
      </p>
    </div>
  );
}
